import { type ObjectMode } from '@databases/types';
import { type Database, DatabaseFieldType } from '@databases/types/database';
import { createField, getExistingDatabase } from '@databases/utils/database/utils';

import { databasesToContentId } from './constants.ts';

export const databaseWithBasicFields = (): Database<ObjectMode.EXISTING> => {
  const baseDatabase = getExistingDatabase({
    contentId: databasesToContentId['databaseWithBasicFields']
  });

  const selectOptions = [
    {
      color: 'tealLight',
      id: '1',
      label: 'Small'
    },
    {
      color: 'yellowLight',
      id: '2',
      label: 'Medium'
    },
    {
      color: 'greenLight',
      id: '3',
      label: 'Large'
    },
    {
      color: 'tealLight',
      id: '4',
      label: 'Extra Small'
    },
    {
      color: 'greenLight',
      id: '5',
      label: 'Extra Large'
    },
    {
      color: 'redLight',
      id: '6',
      label: '"One-size-fits-all"'
    },
    {
      color: 'purpleLight',
      id: '7',
      label: 'No preference, any available'
    }
  ];
  const baseSelectField = createField(DatabaseFieldType.SELECT);
  const baseSelectFieldMulti = createField(DatabaseFieldType.SELECT);

  const fields = [
    {
      ...createField(DatabaseFieldType.TEXT),
      name: `Text Field`
    },
    {
      ...createField(DatabaseFieldType.ATTACHMENT),
      name: `Attachment Field`
    },
    {
      ...createField(DatabaseFieldType.NUMBER),
      name: `Number Field`
    },
    {
      ...createField(DatabaseFieldType.DATE),
      name: `Date Field`
    },
    {
      ...baseSelectField,
      name: `Tag Field`,
      settings: {
        ...baseSelectField.settings,
        multi: false,
        selectOptions: [
          ...selectOptions,
          {
            color: 'purpleLight',
            id: '8',
            label: 'Other'
          },
          {
            color: 'purpleLight',
            id: '9',
            label: 'None'
          }
        ]
      }
    },
    {
      ...baseSelectFieldMulti,
      name: `Tag Field (multi)`,
      settings: {
        ...baseSelectField.settings,
        multi: true,
        selectOptions
      }
    },
    {
      ...createField(DatabaseFieldType.USER),
      name: `User Field`
    },
    {
      ...createField(DatabaseFieldType.HYPERLINK),
      name: `Link Field`
    },
    { ...createField(DatabaseFieldType.CHECKBOX), name: 'Checkbox Field' }
  ];

  return {
    ...baseDatabase,
    fields: fields.map((field) => field.id),
    fieldsById: Object.fromEntries(fields.map((field) => [field.id, field]))
  };
};
